import JSONFormatter from 'json-formatter-js'

window.JSONFormatter = JSONFormatter;
